<template>
  <div class="widget">
    <div class="title">{{ $t('pages_home_trans_001') }}</div>
    <div class="trans-area">
      <a-skeleton v-if="tradeLoading" active :paragraph="false" />
      <div v-else class="trans-list">
        <div class="module-info" @click="$router.push('/receive/manage')">
          <div class="name">{{ $t('pages_main_014') }}</div>
          <a-skeleton v-if="waitLoading" active :paragraph="false" />
          <div v-else class="amount">{{ waitInfo.receive }}</div>
        </div>
        <div class="module-info" @click="$router.push({ path: '/funds/review', query: { key: 'outbound' } })">
          <div class="name">{{ $t('pages_main_021') }}</div>
          <a-skeleton v-if="waitLoading" active :paragraph="false" />
          <div v-else class="amount">{{ waitInfo.outPay }}</div>
        </div>
        <div class="module-info" @click="$router.push({ path: '/funds/review', query: { key: 'inbound' } })">
          <div class="name">{{ $t('pages_main_020') }}</div>
          <a-skeleton v-if="waitLoading" active :paragraph="false" />
          <div v-else class="amount">{{ waitInfo.pay }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onUnmounted, defineComponent } from 'vue'
// import { useStore } from 'vuex'
import { _home } from '@/api/index'
export default defineComponent({
  name: 'Transactions',
  setup() {
    // const store = useStore()
    const state = reactive({
      waitLoading: true,
      waitInfo: {},
      transList: []
    })

    onUnmounted(() => {
    })

    const init = async () => {
      loadBusStatistics()
    }

    const loadBusStatistics = async () => {
      state.waitLoading = true
      const res = await _home.getBusStatistics()
      if (res.data.succ) {
        state.waitInfo = res.data.data
      }
      state.waitLoading = false
    }

    init()

    return {
      ...toRefs(state)
    }
  }
})
</script>

<style lang="less" scoped>
.trans-area {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
  // round corner
  border-radius: 8px;
  border: solid 1px #E5E9F2;
  .empty {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #A0A7B8;
  }
  .trans-list {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
    padding: 20px;
    .module-info {
      flex: 0 0 33.33%;
      border-right: 1px solid #ECEFFC;
      padding: 0 12px;
      overflow: hidden;
      cursor: pointer;
      .ellipsis {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .name {
        .ellipsis;
        color: @text-color;
        font-weight: 500;
        font-size: 16px;
      }
      .amount {
        .ellipsis;
        margin-top: 8px;
        font-size: 20px;
        font-weight: 500;
        color: #333;
      }
    }
    .module-info:last-child {
      border-right: 0;
    }
  }
}
</style>
